import { gql } from '@apollo/client'

export const SEARCH_LUGGAGE = gql`
    query searchLuggage($id: String, $search_string: String, $status_code: Boolean, $page: PageInput!) {
        searchLuggage(id: $id, search_string: $search_string, status_code: $status_code, page: $page) {
            code
            success
            message 
            luggages {
                luggage_id 
                weight
                dimensions {
                    length
                    width
                    height
                }
                metadata {
                    luggage_type
                    seat_type
                    category
                }
                price {
                    base
                }
                active
            }
        }
    }
`

export const GET_LUGGAGE_DETAILS_FROM_TRIP_BY_TRIP_ID = gql`
    query getLuggageDetailsFromTripByTripId($trip_id: NonEmptyString!, $page: PageInput!) {
        getLuggageDetailsFromTripByTripId(trip_id: $trip_id, page: $page) {
            code
            success
            message 
            trip_luggages {
                trip_luggage_id
                status
                trip_id 
                luggage_detail {
                    luggage_id
                    weight
                    dimensions {
                        length
                        width
                        height
                    } 
                    metadata {  
                        luggage_type
                        seat_type
                        category
                    }
                    price {
                        base 
                    }
                    active 
                } 
            }
        }
    }
`